import { render } from "./PersonsList.vue?vue&type=template&id=2036bf81&scoped=true"
import script from "./PersonsList.vue?vue&type=script&lang=js"
export * from "./PersonsList.vue?vue&type=script&lang=js"

import "./PersonsList.vue?vue&type=style&index=0&id=2036bf81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2036bf81"]])

export default __exports__